import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Facet, FacetValue, ProductSearchService } from '@spartacus/core';
import { FacetList, FacetListComponent } from '@spartacus/storefront';
import { Observable, filter, map } from 'rxjs';
import { HisenseFacetService } from '../../../../features/services/facet.service';

@Component({
  selector: 'cx-facet-list',
  templateUrl: 'facet-list.component.html',
  styleUrls: ['facet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HisenseFacetListComponent extends FacetListComponent {
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  protected override facetService = inject(HisenseFacetService);
  private productSearchService = inject(ProductSearchService);

  override facetList$: Observable<FacetList> = this.facetService.facetList$;
  total$: Observable<number | undefined> = this.productSearchService.getResults().pipe(
    filter((data) => !!data?.pagination),
    map((results) => results.pagination?.totalResults)
  );

  resetFacets(facets: Facet[]) {
    const facet: FacetValue | undefined = facets[0]?.values?.[0];
    const query = facet?.query?.query?.value;
    const removeQuery =
      query?.indexOf(':allCategories:') !== -1
        ? query?.substring(0, query?.indexOf(':', query?.indexOf(':allCategories:') + 15)) + ''
        : query?.substring(0, query?.indexOf(':', query?.indexOf(':') + 1));

    this.router.navigate(['./'], {
      queryParams: this.facetService.getLinkParams(removeQuery),
      relativeTo: this.route,
    });
  }
}
